<template>
  <div>
    <div v-if="!isLoading && selectedClaim" class="greybox">
      <h1>Claim details...</h1>
      <div class="claim-list-card mt-3">
        <div class="claim-list-card-body">
          <div class="row">
            <div class="col-sm-6">
              <p>
                <strong>Claim reference</strong>
              </p>
            </div>
            <div class="col-sm-6">
              <p>{{selectedClaim.claimReference}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <p>
                <strong>Policy number</strong>
              </p>
            </div>
            <div class="col-sm-6">
              <p>{{selectedClaim.policyNo}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <p>
                <strong>Claim submitted</strong>
              </p>
            </div>
            <div class="col-sm-6">
              <p>{{selectedClaim.submitted}}</p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-sm-6">
              <p>
                <strong>Current status</strong>
              </p>
            </div>
            <div class="col-sm-6">
              <p>{{selectedClaim.status}}</p>
              <button class="button-small" @click="showHistory">View claim history</button>
            </div>
          </div>

          <b-modal
            id="historyModal"
            ref="historyModal"
            :title="selectedClaim.claimReference"
            :hide-footer="true"
            size="lg"
          >
            <div class="greybox">
              <h1 class="mb-3">Claim status history</h1>
              <timeline-display
                :items="selectedClaim.statusHistory"
                :title_prop="'date'"
                :body_prop="'label'"
              />
              <button class="button mt-3" @click="() => { $refs.historyModal.hide() }">Close</button>
            </div>
          </b-modal>

          <div v-if="bankDetailsRequired">
            <div class="row" v-if="!isBankDetailsEmpty">
              <div class="col-sm-6">
                <p>
                  <strong>Bank account</strong>
                </p>
              </div>
              <div class="col-sm-4">
                <div class="row" v-if="selectedClaim.bankDetails.accountNumber !== null">
                  <div class="col-lg-6">Account Number:</div>
                  <div class="col-lg-4">
                    <p>{{selectedClaim.bankDetails.accountNumber}}</p>
                  </div>
                </div>
                <div class="row" v-if="selectedClaim.bankDetails.accountSortcode !== null">
                  <div class="col-lg-6">Sort Code:</div>
                  <div class="col-lg-4">
                    <p>{{selectedClaim.bankDetails.accountSortcode | sortCodeFilter}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Bank account</strong>
                  </p>
                </div>
                <div class="col-sm-4">
                  <button class="button-small" @click="handleEditBank(true)">Add bank details</button>
                  <div
                    class="mt-2 alert alert-warning"
                    role="alert"
                  >We need this so we can reimburse you for your claim minus any excess owed.</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <a
                href="javascript:void(0);"
                class="float-right"
                v-on:click="claimDetailsShowMore = !claimDetailsShowMore"
              >{{claimDetailsShowMore == true ? 'Show less' : 'Show more'}}</a>
            </div>
          </div>
          <div v-if="claimDetailsShowMore == true">
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <strong>Incident type</strong>
                </p>
              </div>
              <div class="col-sm-6">
                <p>{{selectedClaim.incidentType}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <strong>Date</strong>
                </p>
              </div>
              <div class="col-sm-6">
                <p>{{selectedClaim.incidentDate}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <strong>Time</strong>
                </p>
              </div>
              <div class="col-sm-6">
                <p>{{selectedClaim.incidentTime}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <strong>Location</strong>
                </p>
              </div>
              <div class="col-sm-6">
                <p>{{selectedClaim.incidentLocation}}</p>
              </div>
            </div>
          </div>

          <div v-if="selectedClaim.incidentOccourredAbroad">
            <div class="claim-list-card-body">
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Trip dates</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{selectedClaim.tripStartEndDate}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Country</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{selectedClaim.country}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="selectedClaim.gadgets">
        <div
          v-for="(gadget, index) in selectedClaim.gadgets"
          :key="index"
          class="claim-list-card mt-3"
        >
          <div class="claim-list-card-body">
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <strong>Gadget {{index + 1}}</strong>
                </p>
              </div>
              <div class="col-sm-6">
                <p>{{gadget.displayName}}</p>
              </div>
            </div>
            <div v-if="showOptions">
              <div v-if="gadget.repairOption" class="row">
                <div class="col">
                  <p>
                    <strong>Settlement option</strong>
                  </p>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <p>{{gadget.repairOption.displayName}}</p>
                    </div>
                    <div class="col">
                      <a
                        class="mb-2"
                        href="javascript:void(0)"
                        @click="showRepairOptionInstructionss(gadget)"
                      >View instructions</a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <button
                        v-if="gadget.repairOption.allowCancel"
                        class="button-small mr-2 mb-2"
                        @click="cancelRepairOption(gadget)"
                      >Cancel option</button>
                      <button
                        v-if="gadget.repairOption.requireInvoiceUpload"
                        class="button-small mb-2"
                        @click="showFredEx(gadget)"
                      >Upload repair invoice</button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <user-acc-rem-notification v-if="shouldDisplayUserAccNotn(gadget.repairOption)" :optionWebReference="gadget.repairOption.webReference" />
                      <div class="row">
                        <div class="col mb-2">
                          <selected-option-status
                            :gadgetWebReference="gadget.id"
                            :excessAmount="getExcessAmountFromGadget(gadget)"
                            :trackingId="gadget.repairOption.dispatchTrackingId"
                          />
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Selected settlement option</strong>
                  </p>
                </div>
                <div v-if="selectedClaim.status === 'APPROVED'" class="col-sm-6">
                  <button
                    class="button-small mb-2"
                    @click="showRepairOptions(gadget)"
                  >Select an option</button>
                </div>
                <div v-else class="col-sm-6">
                  <div class="alert">
                    <div class="icon-strip"><img :src="require('../assets/theme/' + resellerId + '/images/help.svg')" alt="Help" title="Help" class="icon"></div>
                    <div class="alert-body">You are unable to select a settlement option until your claim has been approved.</div>
                    <div class="clearfix"></div>    
                  </div>
                  <!-- <p>You are unable to select a settlement option until your claim has been approved.</p> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <a
                  href="javascript:void(0);"
                  class="float-right"
                  v-on:click="gadgetDetailsShowMoreByIndexToggle(index)"
                >{{gadgetDetailsShowMoreTextByIndex(index)}}</a>
              </div>
            </div>
            <div v-if="gadgetDetailsShowMoreByIndex(index)">
              <div
                class="row"
                v-if="gadget.excessCardPayment && gadget.excessCardPayment.statusId == 1001"
              >
                <div class="col-sm-6">
                  <p>
                    <strong>Excess</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>&pound;{{gadget.excessCardPayment.amount}} paid on {{gadget.excessCardPayment.date}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Details</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.details}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Contract details</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.contractDetails}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Purchased from</strong>
                  </p>
                </div>
                <div class="col-6">
                  <p>{{gadget.purchasedFrom}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Purchased by</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.purchasedBy}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Condition</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.condition}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Damage</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.damage}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Possesion details</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.possessionDetails}}</p>
                </div>
              </div>
              <div v-if="gadget.blacklistRequestDate" class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Blacklist requested</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.blacklistRequestDate}}</p>
                </div>
              </div>
              <div v-if="gadget.reported" class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Reported to police</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.reportedDate}}</p>
                </div>
              </div>
              <div v-if="gadget.stationAddress" class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Station address</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.stationAddress}}</p>
                </div>
              </div>
              <div v-if="gadget.crimeReference" class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Crime reference</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.crimeReference}}</p>
                </div>
              </div>
              <div v-if="gadget.location && gadget.location != ''" class="row">
                <div class="col-sm-6">
                  <p>
                    <strong>Location</strong>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p>{{gadget.location}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="claim-list-card mt-3">
        <div class="claim-list-card-body">
        
          <form-alert 
            class="mt-3" 
            :show="isApproved" 
            :flavour="isVM ? 1 : 0" 
            :resellerId="resellerIdAsNumber">
              Your claim has been approved so we do not require you to upload any supporting documents.
          </form-alert>
       

          <div class="text-center">
            <button class="button" @click="handleUploadClick()" :disabled="isApproved">Upload supporting documents</button>
          </div>
          <hr />
          <div v-for="(document, index) in selectedClaim.documents" :key="index" class="row mt-3">
            <div class="col-sm-6">
              <p>
                <strong>{{document.typeLabel}}</strong>
              </p>
            </div>
            <div class="col-sm-6">
              <form-document-link :resellerId="resellerIdAsNumber" :document="document"></form-document-link>
              <!-- <p>{{document.originalFilename}}</p>
              <img
                v-if="document.mimeType.includes('image')"
                :src="imgUrl + document.internalFilename"
                class="img-thumbnail"
              />
              <p v-else class="document-claim-view-new-window">
                <img :src="require('../assets/theme/' + resellerId + '/images/new-window.svg')" alt="New window" title="New window" class="icon icon-claim-view-new-window"></img> 
                <a
                  :href="imgUrl + document.internalFilename"
                  target="_blank"
                >Click here to download / view file</a>
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span>Loading...</span>
    </div>

    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import FormAlert from '@/components/FormAlert.vue'
import FormDocumentLink from '@/components/FormDocumentLink.vue'
import taskList from "@/components/TaskList.vue";
import optionsList from "@/components/RepairOptionsList.vue";
import cardDetails from "@/components/CardDetails.vue";
import loading from "vue-loading-overlay";

import timelineDisplay from "@/components/TimelineDisplay.vue";

import axios from "axios";
import { authHeader } from "@/util/authHeader";
import moment from "moment";

import SelectedOptionStatus from "@/components/SelectedOptionStatus.vue";
import UserAccRemNotification from '@/components/UserAccRemNotification.vue'
const initialData = {};

export default {
  name: "claimView",
  components: {
    FormAlert,
    FormDocumentLink,
    taskList,
    optionsList,
    cardDetails,
    loading,
    timelineDisplay,
    SelectedOptionStatus,
    UserAccRemNotification
  },
  mounted() {
    this.load(this.$route.params.id);
  },
  data: () => {
    return {
      excessCardDetails: {
        name: "",
        number: "",
        expiryDate: "",
        code: "",
        line1: "",
        line2: "",
        town: "",
        county: "",
        postcode: "",

        selectedProvider: null
      },
      userSelectedOption: null,
      cardDetailsValid: false,
      paymentResponse: null,
      setRepairOptionResponse: null,
      instructions: null,

      claimDetailsShowMore: false,
      gadgetDetailsShowMore: []
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.myclaims.loading;
    },
    selectedClaim() {
      return this.$store.state.myclaims.selectedClaim;
    },
    imgUrl() {
      return process.env.VUE_APP_API_BASE_URL + "/api/v1/document/download/";
    },
    totalExcess() {
      return this.$store.state.repairoptions.totalExcess;
    },
    isBankDetailsEmpty() {
      let { bankDetails } = this.$store.state.myclaims.selectedClaim;
      if (bankDetails) {
        return bankDetails.name == "" || bankDetails.name == null;
      }
      return true;
    },
    isWalkInRepair() {
      let {
        repairOption
      } = this.$store.state.myclaims.selectedClaim.gadgets[0];
      if (repairOption) {
        if (repairOption.repairOptionTypeId === 1000) {
          return true;
        } else {
          return false;
        }
      }
    },
    isIncidentTypeADMB() {
      let { selectedClaim } = this;
      if (selectedClaim) {
        let { incidentTypeId, incidentParentTypeId } = selectedClaim;

        return (
          incidentTypeId == 1000 ||
          incidentParentTypeId == 1000 ||
          incidentTypeId == 1003 ||
          incidentParentTypeId == 1003
        );
      }
      return false;
    },
    showOptions() {
      return true;
    },
    isIncidentTypeAD() {
      let { selectedClaim } = this;
      if (selectedClaim) {
        let { incidentTypeId, incidentParentTypeId } = selectedClaim;

        return incidentTypeId == 1000 || incidentParentTypeId == 1000;
      }
      return false;
    },
    bankDetailsRequired() {
      if (this.selectedClaim) {
        if (
          this.selectedClaim.gadgets &&
          this.selectedClaim.gadgets.length > 0
        ) {
          for (let i = 0; i < this.selectedClaim.gadgets.length; i++) {
            let gadget = this.selectedClaim.gadgets[i];
            if (gadget) {
              if (gadget.repairOption) {
                if (gadget.repairOption.repairOptionTypeId == 1007) {
                  return true;
                }
              }
            }
          }
        }
      }
      return false;
    },
    isApproved () {
      if (this.selectedClaim && 
        this.selectedClaim.hasOwnProperty("status")) {
          if (this.selectedClaim.status === 'APPROVED') {
            return true
          }
      }
      return false;
    },
    hasDocuments () {
      if (this.selectedClaim &&
        this.selectedClaim.hasOwnProperty("documents") && 
        Array.isArray(this.selectedClaim.documents) &&
        this.selectedClaim.documents.length > 0) {
          return true;
      }

      return false;
    },
    resellerId() {
      return process.env.VUE_APP_RESELLER_ID
    },
    resellerIdAsNumber () {
      const id = Number(process.env.VUE_APP_RESELLER_ID)
      if (id == 'NaN') {
        return -1
      }
      return id;
    },
    isVM() {
      return process.env.VUE_APP_RESELLER_ID == 77
    }
  },
  watch: {
    selectedClaim: function(val) {
      if (this.selectedClaim && this.selectedClaim.gadgetDetails) {
        for (let i = 0; i < this.selectedClaim.gadgetDetails.length; i++) {
          try {
            this.gadgetDetailsShowMore.push(true);
          } catch (err) {
            console.log(err);
          }
        }
      }
    }
  },
  methods: {
    ...mapActions({
      load: "myclaims/getClaim",
      setGadget: "myclaims/setSelectedGadget",
      reset: "myclaims/resetClaim",
      loadOptions: "repairoptions/getRepairOptionsList"
    }),
    showHistory() {
      this.$refs.historyModal.show();
    },
    showRepairOption(id) {
      this.loadOptions(id);
      this.$refs["repairOptionModal_" + id][0].show();
    },
    showRepairOptions(gadget) {
      // this.$refs.testModal.gadget = gadget;
      // this.$refs.testModal.totalExcess = this.totalExcess;
      // this.$refs.testModal.show();
      this.setGadget(gadget);
      this.$router.push({ path: "/myclaims/repairoptions/list" });
    },
    showRepairOptionInstructionss(gadget) {
      this.setGadget(gadget);

      this.$router.push({ path: "/myclaims/repairoptions/instructions" });
    },
    cancelRepairOption(gadget) {
      this.setGadget(gadget);
      this.$router.push({ path: "/myclaims/repairoptions/cancel" });
    },
    showFred(gadget) {
      this.$refs.fred.gadget = gadget;
      this.$refs.fred.show();
    },
    showFredEx(gadget) {
      this.setGadget(gadget);
      if (this.isBankDetailsEmpty) {
        this.handleEditBank(false);
      } else {
        this.$router.push({ path: "/myclaims/repairoptions/uploaddocs" });
      }
    },
    handleEditBank(standAlone) {
      if (standAlone) {
        this.$router.push({
          name: "repairoptionseditbankdetails",
          params: { id: this.selectedClaim.id, standAlone: true }
        });
      } else {
        this.$router.push({ path: "/myclaims/repairoptions/bankdetails" });
      }
    },
    handlepaymentDetailsIsValid(value) {
      this.cardDetailsValid = value;
    },
    optionSelected(option) {
      this.userSelectedOption = option;
    },
    handleRepairOptionModalHidden() {
      this.userSelectedOption = null;
      // this.instructions = null;
      this.load(this.$route.params.id);
    },
    handleFredModalHidden() {
      this.load(this.$route.params.id);
    },
    handlePayExcessClick(gadgetId) {
      let paymentDetails = {
        claimWebReference: this.selectedClaim.claimWebReference,
        gadgetWebReference: gadgetId,
        cardTypeId: this.excessCardDetails.provider,
        cardName: this.excessCardDetails.name,
        cardNumber: this.excessCardDetails.number,
        cardSecurityCode: this.excessCardDetails.code,
        cardExpiry: this.excessCardDetails.expiryDate,
        cardLine1: this.excessCardDetails.line1,
        cardLine2: this.excessCardDetails.line2,
        cardTown: this.excessCardDetails.town,
        cardCounty: this.excessCardDetails.county,
        cardPostcode: this.excessCardDetails.postcode
      };

      axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/api/v1/payment/",
          paymentDetails,
          { headers: authHeader() }
        )
        .then(response => {
          this.paymentResponse = response.data.data;

          if (this.paymentResponse.paymentSuccess == true) {
            let opt = {
              ...this.userSelectedOption,
              gadgetWebRef: gadgetId,
              claimWebRef: this.selectedClaim.id
            };

            axios
              .post(
                process.env.VUE_APP_API_BASE_URL + "/api/v1/repairoptions/",
                opt,
                { headers: authHeader() }
              )
              .then(response => {
                // this.showErr = false;

                this.setRepairOptionResponse = response.data.data;
                if (this.setRepairOptionResponse.success == true) {
                  // if (this.setRepairOptionResponse.otCode) {
                  //     this.$router.push( { path: '/booking/?ot=' + this.setRepairOptionResponse.otCode } );
                  // }

                  this.instructions = this.setRepairOptionResponse.instructionsHTML;
                  this.load(this.$route.params.id);
                  // this.showThanks = true;
                }
              })
              .catch(error => {
                // this.showErr = true;
              });
            // .finally( () => this.isLoading = false )
          } else {
            this.showPamentAdvice =
              this.paymentResponse.paymentAdvice &&
              this.paymentResponse.paymentAdvice != "";
          }
        })
        .catch(error => {
          this.showErr = true;
        });
      // .finally( () => this.isLoading = false )
    },
    handleUpdateClaimClick(gadgetId) {
      let self = this;

      let opt = {
        ...this.userSelectedOption,
        gadgetWebRef: gadgetId,
        claimWebRef: this.selectedClaim.id
      };

      axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/api/v1/repairoptions/",
          opt,
          { headers: authHeader() }
        )
        .then(response => {
          this.showErr = false;

          this.setRepairOptionResponse = response.data.data;
          if (this.setRepairOptionResponse.success == true) {
            // if (this.setRepairOptionResponse.otCode) {
            //     this.$router.push( { path: '/booking/?ot=' + this.setRepairOptionResponse.otCode } );
            // }

            this.instructions = this.setRepairOptionResponse.instructionsHTML;
            // this.load(this.$route.params.id);
            // this.showThanks = true;
          }

          // this.showErr = false;

          // this.showThanks = true;
        })
        .catch(err => {
          // this.showErr = true;
        });
      // .finally( () => this.isLoading = false );
    },
    handleCancelOptionClick(gadgetId) {
      let self = this;

      let opt = {
        ...this.userSelectedOption,
        gadgetWebRef: gadgetId,
        claimWebRef: this.selectedClaim.id
      };

      axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/v1/repairoptions/cancelforgadget/" +
            gadgetId,
          { headers: authHeader() }
        )
        .then(response => {
          this.showErr = false;

          this.setRepairOptionResponse = response.data.data;
          if (this.setRepairOptionResponse.success == true) {
            // if (this.setRepairOptionResponse.otCode) {
            //     this.$router.push( { path: '/booking/?ot=' + this.setRepairOptionResponse.otCode } );
            // }

            this.instructions = this.setRepairOptionResponse.instructionsHTML;
            // this.load(this.$route.params.id);
            // this.showThanks = true;
          }

          // this.showErr = false;

          // this.showThanks = true;
        })
        .catch(err => {
          // this.showErr = true;
        });
      // .finally( () => this.isLoading = false );
    },
    handleUploadClick() {
      this.$router.push({ path: "/myclaims/supportingdocs" });
    },
    FormatDate(dte) {
      return moment(dte).format("DD/MM/YYYY");
    },
    gadgetDetailsShowMoreByIndex(idx) {
      if (this.gadgetDetailsShowMore) {
        return this.gadgetDetailsShowMore[idx];
      } else {
        return true;
      }
    },
    gadgetDetailsShowMoreTextByIndex(idx) {
      if (this.gadgetDetailsShowMore) {
        return this.gadgetDetailsShowMore[idx] == true
          ? "Show less"
          : "Show more";
      }
      return "Show more";
    },
    gadgetDetailsShowMoreByIndexToggle(idx) {
      if (this.gadgetDetailsShowMore) {
        this.$set(
          this.gadgetDetailsShowMore,
          idx,
          !this.gadgetDetailsShowMore[idx]
        );
        //this.gadgetDetailsShowMore[idx] = !this.gadgetDetailsShowMore[idx];
      }
    },
    getExcessAmountFromGadget(gadget) {
      if (
        gadget.excessCardPayment &&
        gadget.excessCardPayment.statusId == 1001
      ) {
        return `£${gadget.excessCardPayment.amount}`;
      } else {
        return null;
      }
    },
    shouldDisplayUserAccNotn (option) {
      if (option) {
        if (option.userAccountActive == true) {
          if (option.usrAccCustomerDateCreated) {
            if (moment(option.userAccountActiveLastUpdated).isAfter(option.usrAccCustomerDateCreated)) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  filters: {
    sortCodeFilter: function(value) {
      if (!value) return "";
      value = value.toString();
      return (
        value.slice(0, 2) + "-" + value.slice(2, 4) + "-" + value.slice(4, 6)
      );
    }
  }
};
</script>
